/**
 * Premium theme registry — drives the sidebar Appearance picker.
 *
 * Each premium theme is a distinct colour world applied via
 * `body.v3-premium[data-pm-theme="<id>"]` (see premium-skin.css). `mode` tells
 * the picker to also flip the underlying dark/light base so text + legacy pages
 * stay readable. `swatch` is a CSS gradient shown in the picker chip.
 *
 * 'classic' is the original V3 look (no premium skin) — always the first option.
 */
export const CLASSIC_OPTION = {
    id: 'classic',
    name: 'Classic',
    sub: 'Original V3 · Dark',
    mode: 'dark',
    swatch: 'linear-gradient(135deg, #334155, #0f172a)',
};

// All premium themes render on a light / white foundation — the accent colours
// tint a porcelain UI (dark is no longer the default). `mode: 'light'` flips the
// base so text + legacy pages stay readable.
export const PREMIUM_THEMES = [
    {
        id: 'aurora',
        name: 'Aurora',
        sub: 'Blue · Cyan',
        mode: 'light',
        swatch: 'linear-gradient(135deg, #2563EB, #06B6D4)',
    },
    {
        id: 'nebula',
        name: 'Nebula',
        sub: 'Violet · Magenta',
        mode: 'light',
        swatch: 'linear-gradient(135deg, #7C3AED, #DB2777)',
    },
    {
        id: 'emerald',
        name: 'Emerald',
        sub: 'Green · Teal',
        mode: 'light',
        swatch: 'linear-gradient(135deg, #059669, #0891B2)',
    },
    {
        id: 'sunset',
        name: 'Sunset',
        sub: 'Amber · Rose',
        mode: 'light',
        swatch: 'linear-gradient(135deg, #EA580C, #E11D48)',
    },
    {
        id: 'platinum',
        name: 'Gold',
        sub: 'Golden Yellow',
        mode: 'light',
        swatch: 'linear-gradient(135deg, #FCD34D, #F59E0B)',
    },
];

export const ALL_SKINS = ['classic', ...PREMIUM_THEMES.map((t) => t.id)];

export const THEME_MODE = PREMIUM_THEMES.reduce(
    (acc, t) => ((acc[t.id] = t.mode), acc),
    {},
);
